import { generatePath, useNavigate } from 'react-router';
import { PerformanceBadge } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useEligibleBidNomination } from '~/domain/BestInDental';
import { routes } from '~/routes';
import { ShiftCard } from '../ShiftCard';

/**
 * Dashboard "Best in Dental" quick-apply tile (GOTU-6482). Sits alongside the
 * shift status tiles and renders only while the office has an apply-eligible
 * BID nomination — a `nominee` membership whose cycle is still inside its
 * application window. Applying (status → `applicant`) or the window closing
 * clears `applyEligible`, so the tile disappears on the next history refetch.
 *
 * Rendered through `ShiftCard` (icon variant) so it matches the shift tiles'
 * shell, hover, and accent bar exactly. No analytics event is fired — BID
 * client tracking is intentionally out of scope.
 */
export const BidNominationCard = () => {
  const navigate = useNavigate();
  const { eligibleItem } = useEligibleBidNomination();

  if (!eligibleItem) {
    return null;
  }

  const handleClick = () => {
    navigate(generatePath(routes.bestInDentalApplication, { cycleId: eligibleItem.cycleId }));
  };

  return (
    <ShiftCard
      title="Best in Dental"
      icon={<PerformanceBadge variant="best-in-dental" size="medium" aria-hidden />}
      barColor={colors.success[500]}
      ctaText="Apply now"
      isClickable
      onClick={handleClick}
      dataCy="bid-nomination-card"
    />
  );
};
